import React from 'react';
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io';
import { Flex, Icon, Button } from '@chakra-ui/react';

interface ScrollButtonProps {
  diretion: string;
  handleClick: (param?: string) => void;
}

export const ScrollButton: React.FC<ScrollButtonProps> = ({
  diretion,
  handleClick,
}) => {
  if (diretion === 'right')
    return (
      <Flex
        aria-hidden="true"
        as={Button}
        h="32px"
        w="32px"
        minWidth={0}
        bg="button"
        opacity="50%"
        borderRadius={999}
        onClick={() => handleClick()}
        zIndex={2}
      >
        <Icon
          as={IoIosArrowForward}
          color="white"
          alignSelf="center"
          zIndex={2}
          position="absolute"
          h="18px"
          w="18px"
        />
      </Flex>
    );

  return (
    <Flex
      aria-hidden="true"
      as={Button}
      h="32px"
      w="32px"
      minWidth={0}
      bg="button"
      opacity="50%"
      borderRadius={999}
      onClick={() => handleClick()}
      zIndex={2}
    >
      <Icon
        as={IoIosArrowBack}
        color="white"
        alignSelf="center"
        zIndex={2}
        position="absolute"
        h="18px"
        w="18px"
      />
    </Flex>
  );
};
